import React from 'react';

export default class ModalAddNote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        isEdit: false,
        isOver24Hours: false,
        note_title: "",
        note_content: "",
        hand_text: ""
    };

    var note_title = '';
    var note_content = '';
    var hand_text = '';
    switch (props.notes.handSide) {
        case 'LT':
            note_title = props.notes.noteTitleLT;
            note_content = props.notes.noteContentLT;
            hand_text = "Left Dorsal";
            break;
        case 'LB':
            note_title = props.notes.noteTitleLB;
            note_content = props.notes.noteContentLB;
            hand_text = "Left Palmar";
            break;
        case 'RT':
            note_title = props.notes.noteTitleRT;
            note_content = props.notes.noteContentRT;
            hand_text = "Right Dorsal";
            break;
        default:
            note_title = props.notes.noteTitleRB;
            note_content = props.notes.noteContentRB;
            hand_text = "Right Palmar";
            break;
     }

     this.state.isOver24Hours = props.isOver24Hours;
     this.state.hand_text = hand_text;
     if((note_title && note_content) && (note_title !== '' || note_content !== '')) {
         this.state.note_title = note_title;
         this.state.note_content = note_content;
         this.state.isEdit = true;
     }
  }

  handleChange = (event) => {
      const { target: { name, value } } = event;
      this.setState({ [name]: value });
  }

  editMode = () => {
     this.setState({ isEdit: false });
  }

  handleConfirm = () => {
      let notes = {
          note_title: this.state.note_title,
          note_content: this.state.note_content,
      }
      this.props.handleModal(notes);
  }

  componentDidMount() {
      window.loadScrollable();
  }

  render() {
      const { onShow } = this.props;
      if(!onShow)
        return (null);

      const { isEdit, isOver24Hours, hand_text } = this.state;
      return (
          <div className="modal-block modal-header-color modal-block-primary">
              <section className="card">
                  <header className="card-header">
                      <h2 className="card-title">Notes For {hand_text}</h2>
                  </header>
                  <div className="card-body">
                      <div className="modal-wrapper">
                          <div className="modal-text">
                              <form className="form-horizontal form-bordered" method="POST">
                                  <div className="form-group row">
                                      <label className="col-lg-3 control-label text-lg-right pt-2">Diagnosis</label>
                                  {!isEdit ? (
                                      <div className="col-lg-9">
                                          <div className="input-group">
                                              <span className="input-group-addon">
                                                  <i className="fa fa-notes-medical"></i>
                                              </span>
                                              <input type="text" name="note_title" className="form-control"
                                                value={this.state.note_title}
                                                onChange={this.handleChange} />
                                          </div>
                                      </div>
                                  ) : (
                                      <label className="col-lg-9 control-label text-lg-left pt-2">
                                          {this.state.note_title}
                                      </label>
                                  )}
                                  </div>

                                  <div className="form-group row">
                                      <label className="col-lg-3 control-label text-lg-right pt-2">More Information</label>
                                  {!isEdit ? (
                                      <div className="col-lg-9">
                                          <div className="input-group color colorGreen">
                                              <span className="input-group-text input-group-addon"><i className="fa fa-clipboard-list"></i></span>
                                              <textarea name="note_content" className="form-control"
                                                value={this.state.note_content}
                                                onChange={this.handleChange}
                                                style={{height: 150}} />
                                          </div>
                                      </div>
                                  ) : (
                                      <label className="col-lg-9 control-label text-lg-left pt-2">
                                          <div className="scrollable visible-slider colored-slider" data-plugin-scrollable style={{height: 150}}>
                                              <div className="scrollable-content">
                                                    <p>{this.state.note_content}</p>
                                              </div>
                                          </div>
                                      </label>
                                  )}
                                  </div>
                              </form>
                          </div>
                      </div>
                  </div>
                  <footer className="card-footer">
                      <div className="row">
                          <div className="col-md-12 text-right">
                              {isEdit && !isOver24Hours ? (
                                  <button type="button" className="btn btn-primary" onClick={this.editMode}>Edit Note</button>
                              ) : (null)}
                              {!isEdit ? (
                                  <button className="btn btn-primary modal-confirm" onClick={this.handleConfirm}>Confirm</button>
                              ):(null)}
                              <button className="btn btn-default modal-dismiss" onClick={this.props.onHide}>Cancel</button>
                          </div>
                      </div>
                  </footer>
              </section>
          </div>
      )
	}
}
